import { Link } from "react-router-dom";

const CategoryCard = ({ category }) => {
  return (
    <Link
      to={category.link}
      className="relative h-48 md:h-64 rounded-2xl overflow-hidden group"
    >
      <img
        src={category.image}
        alt={category.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />

      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
        <h3 className="text-white text-2xl md:text-3xl font-bold uppercase tracking-wide">
          {category.title}
        </h3>
      </div>
    </Link>
  );
};

export default CategoryCard;
